import { SVGProps } from "react";
import { useTranslations } from "next-intl";
import Link from "next/link";
import LocaleSwitcher from "./LocaleSwitcher";

import InformationCircle from "@/components/icons/information-circle.svg";
import Newspaper from "@/components/icons/newspaper.svg";
import MapPin from "@/components/icons/map-pin.svg";
import Briefcase from "@/components/icons/briefcase.svg";
import BuildingOffice from "@/components/icons/building-office.svg";
import Phone from "@/components/icons/phone.svg";
import User from "@/components/icons/user.svg";
import ShoppingCart from "@/components/icons/shopping-cart.svg";
import ArrowLeftStartOnRectangle from "@/components/icons/arrow-left-start-on-rectangle.svg";
import { FetchResDesctructure } from "@/app/lib/fetch-utils";

interface SideMenuProps {
  type: "main" | "user";
  open?: boolean;
  close?: () => void;
  divRef: React.Ref<HTMLDivElement>;
}

interface MenuItemLink {
  type: "link";
  path: string;
  label: string;
  icon: (props: SVGProps<SVGSVGElement>) => React.JSX.Element;
}

interface MenuItemButton {
  type: "button";
  label: string;
  icon: (props: SVGProps<SVGSVGElement>) => React.JSX.Element;
  onClick: () => void;
}

type MenuItem = MenuItemLink | MenuItemButton;

const mainMenuItems: MenuItem[] = [
  {
    type: "link",
    path: "/ueber-uns",
    label: "weAreInvento",
    icon: InformationCircle,
  },
  {
    type: "link",
    path: "/blog",
    label: "magazine",
    icon: Newspaper,
  },
  {
    type: "link",
    path: "/standorte",
    label: "partnersAndLocations",
    icon: MapPin,
  },
  {
    type: "link",
    path: "/services",
    label: "services",
    icon: Briefcase,
  },
  {
    type: "link",
    path: "/ueber-uns#karriere",
    label: "sub-3",
    icon: BuildingOffice,
  },
  {
    type: "link",
    path: "/#kontakt",
    label: "contact",
    icon: Phone,
  },
]

const accountMenuItems: MenuItem[] = [
  {
    type: "link",
    path: "/kundenkonto/bestellungen",
    label: "client-orders",
    icon: ShoppingCart,
  },
  {
    type: "link",
    path: "/kundenkonto",
    label: "client-account",
    icon: User,
  },
  {
    type: "button",
    onClick: logout,
    label: "client-logout",
    icon: ArrowLeftStartOnRectangle,
  },
];

async function logout() {
  await fetch("/api/auth/logout", { method: "POST" })
    .then(FetchResDesctructure<boolean>)
    .then(({ status, ok, body }) => {
      if (ok) {
        window.location.reload();
      } else {

      }
    })
}

function SideMenu(props: SideMenuProps) {
  const t = useTranslations("Menu");

  if (!props.open) {
    return null;
  }

  let relevantItems: MenuItem[];
  if (props.type === "main") {
    relevantItems = mainMenuItems;
  } else if (props.type === "user") {
    relevantItems = accountMenuItems;
  } else {
    throw new Error('Invalid menu type');
  }

  return (
    <div className="top-[77px] right-0 z-100 fixed bg-white font-[Outfit] font-extrabold text-[#18181b] py-10 px-7 shrink-0 h-[calc(100%-77px)] border-1 border-[#00000066] flex flex-col" ref={props.divRef}>
      <div className="flex-auto">
        {relevantItems.map((item, index) => {
          if (item.type === "link") {
            return (
              <Link key={`side_menu_${index}`} href={item.path} className="shrink-0" onClick={props.close}>
                <div className="px-[20px] py-[6px] gap-2 flex flex-row shrink-0 w-auto place-items-center">
                  <item.icon height={24} width={24} className="flex-none" />
                  <div className="shrink-0 leading-[180%]">{t(item.label)}</div>
                </div>
              </Link>
            )
          } else if (item.type === "button") {
            return (
              <div key={`side_menu_${index}`} className="px-[20px] py-[6px] gap-2 flex flex-row shrink-0 w-auto place-items-center cursor-pointer" onClick={() => { item.onClick(); (props.close && props.close()); }}>
                <item.icon height={24} width={24} className="flex-none" />
                <div className="shrink-0 leading-[180%]">{t(item.label)}</div>
              </div>
            )
          } else {
            throw new Error(`Invalid item: ${JSON.stringify(item)}`)
          }
        })}
      </div>
      {/*{props.type === "main" && (
        <div className="flex-none font-normal">
          <div className="flex flex-row place-items-center px-[10px] py-[10px] gap-[10px]">
            <div className="flex-auto leading-[200%]">
              Sprache / Languge / Lingua
            </div>
            <LocaleSwitcher className="w-40" />
          </div>
        </div>
      )}*/}
    </div>
  )
}

export default SideMenu;
